<template>
  <el-select filterable v-model="wxgame_playable_page_path" @change="onChange">
    <el-option
      v-for="wxgame in list"
      :key="wxgame.playable_page_path"
      :label="wxgame.playable_page_name"
      :value="wxgame.playable_page_path"
    >
      <div style="display: flex; align-items: center">
        <span>{{ wxgame.playable_page_name }}</span>
        <span>&emsp;</span>
        <span
          :title="wxgame.playable_page_path"
          style="width: 160px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
        >
          {{ wxgame.playable_page_path }}
        </span>
        <span>&emsp;</span>
        <span>{{ wxgame.status_text }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script setup>
import { computed } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  value: String,
  list: Array
})
// eslint-disable-next-line
const emits = defineEmits(['input'])
const wxgame_playable_page_path = computed({
  get() {
    return props.value
  },
  set(val) {
    emits('input', val)
  }
})

function onChange(val) {
  emits('change', val)
}
</script>

<style lang="scss" scoped></style>
